import { createContext } from 'react'
import { ClientConfig } from '../types/ClientConfig'
import { FETCH_STATUS } from '../types/FetchStatus'
import { TokenUsage } from '../types/TokenUsage'
import { UserInfo } from '../types/UserInfo'

export interface AppContextType {
	showMockUI: boolean
	/** The API's deploy-time limits. Falls back to `DEFAULT_CLIENT_CONFIG` until `GET /config` resolves. */
	clientConfig: ClientConfig
	/** `undefined` until the first `GET /usage` resolves, and while there is no user who can spend tokens. */
	usage: TokenUsage | undefined
	/** Re-checks usage. Call after something has spent tokens, or been refused for spending too many. */
	refreshUsage: () => void
	userInfo: UserInfo | undefined
	userInfoStatus: FETCH_STATUS
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const AppContext = createContext<AppContextType>(undefined!)
